
"use strict";

import validateForms from './validateForms';
import Css from './css';
import addToCart from './ajaxCart';
//import Emitter from './globalEmitter';

const validateAddingProductForms = function( context ){
    validateForms( '[data-js-validate-adding-product]', context, function(formElement){
        const inputElements = formElement.elements,
              submitButton = inputElements['add-item-to-cart'],
              qtyInput = inputElements['qty'],
              innerHtmlFromSubmitButton = submitButton ? submitButton.innerHTML : null;
        
        if( inputElements !== null && inputElements.length ){
            // Show loading state immediately
            if (submitButton) {
                submitButton.innerHTML = '';
                submitButton.setAttribute('disabled','');
                Css.addClass(submitButton, 'loading');
                Css.addClass(submitButton, 'loading--center');
                Css.addClass(submitButton, 'loading--no-style');
            }
            if (qtyInput) {
                // Use readonly instead of disabled so the value is still submitted
                qtyInput.setAttribute('readonly', 'readonly');
                qtyInput.style.opacity = '0.6'; // Visual feedback
                qtyInput.style.cursor = 'not-allowed';
            }
            
            // Use the new addToCart function which handles Ajax vs traditional submission
            addToCart(formElement, submitButton, qtyInput);
        } else {
            // Fallback if elements not found
            formElement.submit();
        }
    } );
};

export { validateAddingProductForms };